var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 86.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Degradado_sin_nombre_22);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#Degradado_sin_nombre_23);\n      }\n\n      .cls-3 {\n        fill: url(#Degradado_sin_nombre_21);\n      }\n\n      .cls-4 {\n        fill: url(#Degradado_sin_nombre_11);\n      }\n\n      .cls-26 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-5 {\n        fill: none;\n      }\n\n      .cls-27 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-28 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-29 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-30 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-31 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-32 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-33 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-34 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-35 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-36 {\n        clip-path: url(#clippath-20);\n      }\n\n      .cls-37 {\n        clip-path: url(#clippath-21);\n      }\n\n      .cls-38 {\n        clip-path: url(#clippath-22);\n      }\n\n      .cls-39 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-41 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-42 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-43 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-44 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-45 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-46 {\n        clip-path: url(#clippath-19);\n      }\n\n      .cls-47 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-48 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-6 {\n        fill: url(#Degradado_sin_nombre_21-5);\n      }\n\n      .cls-7 {\n        fill: url(#Degradado_sin_nombre_21-2);\n      }\n\n      .cls-8 {\n        fill: url(#Degradado_sin_nombre_21-3);\n      }\n\n      .cls-9 {\n        fill: url(#Degradado_sin_nombre_21-4);\n      }\n\n      .cls-10 {\n        fill: url(#Degradado_sin_nombre_22-3);\n      }\n\n      .cls-11 {\n        fill: url(#Degradado_sin_nombre_22-2);\n      }\n\n      .cls-12 {\n        fill: url(#Degradado_sin_nombre_22-4);\n      }\n\n      .cls-13 {\n        fill: url(#Degradado_sin_nombre_22-5);\n      }\n\n      .cls-14 {\n        fill: url(#Degradado_sin_nombre_22-6);\n      }\n\n      .cls-15 {\n        fill: url(#Degradado_sin_nombre_11-3);\n      }\n\n      .cls-16 {\n        fill: url(#Degradado_sin_nombre_11-4);\n      }\n\n      .cls-17 {\n        fill: url(#Degradado_sin_nombre_11-2);\n      }\n\n      .cls-18 {\n        fill: url(#Degradado_sin_nombre_11-6);\n      }\n\n      .cls-19 {\n        fill: url(#Degradado_sin_nombre_11-7);\n      }\n\n      .cls-20 {\n        fill: url(#Degradado_sin_nombre_11-5);\n      }\n\n      .cls-21 {\n        fill: url(#Degradado_sin_nombre_11-8);\n      }\n\n      .cls-22 {\n        fill: url(#Degradado_sin_nombre_11-9);\n      }\n\n      .cls-23 {\n        fill: url(#Degradado_sin_nombre_11-11);\n      }\n\n      .cls-24 {\n        fill: url(#Degradado_sin_nombre_11-10);\n      }\n\n      .cls-25 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M445.9,17.9c-18.5.2-21.1,21.9-10,26.1,1.8.9,2.1,2,1.7,3.2-.4,1.3-4,1.5-6.8,1.4-1.1,5.1-5.9,11.9-12.9,14.9,3.3.2,22.7.2,28-.5,13.4-1.7,18.7-14.1,12.8-21.4-1.9-2.4-8-4.2-6.3-7,.9-1.5,3.7-1.5,6.2-1.4-1.2-4,2.5-13.7,9.5-14.9-1,0-6.4,0-11.6,0-4.8,0-9.4,0-10.4,0s-.1,0-.1,0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_11",
    "data-name": "Degradado sin nombre 11",
    x1: -144.5,
    y1: 404.9,
    x2: -143.4,
    y2: 404.9,
    gradientTransform: "translate(6768.2 17829.5) scale(43.9 -43.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2b803"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#d9a012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c56836"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M445.9,17.9c-18.5.2-21.1,21.9-10,26.1,1.8.9,2.1,2,1.7,3.2-.4,1.3-4,1.5-6.8,1.4-1.1,5.1-5.9,11.9-12.9,14.9,3.3.2,22.7.2,28-.5,13.4-1.7,18.7-14.1,12.8-21.4-1.9-2.4-8-4.2-6.3-7,.9-1.5,3.7-1.5,6.2-1.4-1.2-4,2.5-13.7,9.5-14.9-1,0-6.4,0-11.6,0-4.8,0-9.4,0-10.4,0h-.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_11-2",
    "data-name": "Degradado sin nombre 11",
    x1: 443,
    y1: 18,
    x2: 443,
    y2: 62.4,
    gradientTransform: "translate(343.1 -392.8) rotate(71.8)",
    xlinkHref: "#Degradado_sin_nombre_11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M411.1,42.7c-1.8,6.7-4.8,6.4-6.8,6.4-2,0-3.8-1.6-2.6-6.4l6.4-24.6h-18.3c0,0-7.2,27.5-7.2,27.5-3.2,12.2,3.2,17.9,17.6,17.9,15.2,0,22.2-5,26.2-14.4.8-1.9,1.3-5.4,1.9-7.7-4.9-8.2-1.5-19.8,6-23.4h-16.6s-6.6,24.6-6.6,24.6Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_11-3",
    "data-name": "Degradado sin nombre 11",
    x1: -144.7,
    y1: 405,
    x2: -143.5,
    y2: 405,
    gradientTransform: "translate(7038.7 18675.8) scale(46 -46)",
    xlinkHref: "#Degradado_sin_nombre_11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M411.1,42.7c-1.8,6.7-4.8,6.4-6.8,6.4-2,0-3.8-1.6-2.6-6.4l6.4-24.6h-18.3c0,0-7.2,27.5-7.2,27.5-3.2,12.2,3.2,17.9,17.6,17.9,15.2,0,22.2-5,26.2-14.4.8-1.9,1.3-5.4,1.9-7.7-4.9-8.2-1.5-19.8,6-23.4h-16.6s-6.6,24.6-6.6,24.6Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_11-4",
    "data-name": "Degradado sin nombre 11",
    x1: 406.8,
    y1: 18,
    x2: 406.8,
    y2: 62.4,
    gradientTransform: "translate(312.4 -357) rotate(70.9)",
    xlinkHref: "#Degradado_sin_nombre_11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M328,27.4h5.6c5.3,0,6.6,2,5.6,5.8-1.2,4.5-3.9,6-10.5,6h-3.8l3-11.8ZM312,17.8l-11.9,45.7h18.5l3.8-14.7h14.4c9.2,0,17.4-4,20.3-15.1,3.1-11.9-3.3-15.9-13.8-15.9h-31.3Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_11-5",
    "data-name": "Degradado sin nombre 11",
    x1: -144.9,
    y1: 405.1,
    x2: -143.7,
    y2: 405.1,
    gradientTransform: "translate(7645.1 20574.2) scale(50.7 -50.7)",
    xlinkHref: "#Degradado_sin_nombre_11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M328,27.4h5.6c5.3,0,6.6,2,5.6,5.8-1.2,4.5-3.9,6-10.5,6h-3.8l3-11.8ZM312,17.8l-11.9,45.7h18.5l3.8-14.7h14.4c9.2,0,17.4-4,20.3-15.1,3.1-11.9-3.3-15.9-13.8-15.9h-31.3Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_11-6",
    "data-name": "Degradado sin nombre 11",
    x1: 330.2,
    y1: 18,
    x2: 330.2,
    y2: 62.4,
    gradientTransform: "translate(251 -282.5) rotate(69.2)",
    xlinkHref: "#Degradado_sin_nombre_11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M357.3,18.1c1.8.9,8.1,5.3,4.7,17.3-1.4,4.9-5.9,12.2-13.1,14.6l-3.5,13.4h40.1c-3.6-1.5-7.9-6.6-6.7-13.2h-11.7l8.6-32.1h-18.4Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_11-7",
    "data-name": "Degradado sin nombre 11",
    x1: -144.7,
    y1: 404.6,
    x2: -143.5,
    y2: 404.6,
    gradientTransform: "translate(5433.6 14270.6) scale(35.2 -35.2)",
    xlinkHref: "#Degradado_sin_nombre_11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M357.3,18.1c1.8.9,8.1,5.3,4.7,17.3-1.4,4.9-5.9,12.2-13.1,14.6l-3.5,13.4h40.1c-3.6-1.5-7.9-6.6-6.7-13.2h-11.7l8.6-32.1h-18.4Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_11-8",
    "data-name": "Degradado sin nombre 11",
    x1: 365.5,
    y1: 18,
    x2: 365.5,
    y2: 62.4,
    gradientTransform: "translate(311 -323) rotate(75.1)",
    xlinkHref: "#Degradado_sin_nombre_11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M478.8,17.9c-19.8.3-21.1,21.9-10,26.1,1.8.9,2.1,2,1.7,3.2-.4,1.3-2.9,1.5-5.7,1.4.1,2.2-.3,4.3-1.1,6.2,6.1.3,18.7,1.5,19.4-7.1.5-6.1-13.7-9.6-10-17.7,1.2-2.6,2.7-3.7,5.4-4.7-2.6,1.1-4.1,2.1-5.1,4.7-3.4,8.8,13.3,11.7,10.7,19.8-2.7,8.6-14.4,7.6-21.7,7.5-2.2,3.4-5.2,5.7-6.6,6.2,3.3.2,17.8-.2,23.2-.9,13.4-1.7,18.7-13.8,12.7-21.2-1.9-2.4-8-4.2-6.3-7,.9-1.5,4.8-1.5,7.8-1.4,1.2,0,2.2,0,2.9,0,.2-.9,3.6-13.6,4-15-.1,0-2.2,0-5.1,0-2.9,0-6.6,0-10.1,0s-4.1,0-5.9,0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_11-9",
    "data-name": "Degradado sin nombre 11",
    x1: -144.4,
    y1: 404.8,
    x2: -143.2,
    y2: 404.8,
    gradientTransform: "translate(6061.1 15757) scale(38.8 -38.8)",
    xlinkHref: "#Degradado_sin_nombre_11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M478.8,17.9c-19.8.3-21.1,21.9-10,26.1,1.8.9,2.1,2,1.7,3.2-.4,1.3-2.9,1.5-5.7,1.4.1,2.2-.3,4.3-1.1,6.2,6.1.3,18.7,1.5,19.4-7.1.5-6.1-13.7-9.6-10-17.7,1.2-2.6,2.7-3.7,5.4-4.7-2.6,1.1-4.1,2.1-5.1,4.7-3.4,8.8,13.3,11.7,10.7,19.8-2.7,8.6-14.4,7.6-21.7,7.5-2.2,3.4-5.2,5.7-6.6,6.2,3.3.2,17.8-.2,23.2-.9,13.4-1.7,18.7-13.8,12.7-21.2-1.9-2.4-8-4.2-6.3-7,.9-1.5,4.8-1.5,7.8-1.4,1.2,0,2.2,0,2.9,0,.2-.9,3.6-13.6,4-15-.1,0-2.2,0-5.1,0-2.9,0-6.6,0-10.1,0s-4.1,0-5.9,0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_11-10",
    "data-name": "Degradado sin nombre 11",
    x1: 477.9,
    y1: 18,
    x2: 477.9,
    y2: 62.4,
    gradientTransform: "translate(383.7 -429.5) rotate(73.8)",
    xlinkHref: "#Degradado_sin_nombre_11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "477.6 73.5 476.1 79.4 480.6 79.4 481 78 478.4 78 479.5 73.5 477.6 73.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_22",
    "data-name": "Degradado sin nombre 22",
    x1: 478.6,
    y1: 79.4,
    x2: 478.6,
    y2: 73.6,
    gradientTransform: "translate(18.5 -75.8) rotate(9.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b17a26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#cfab4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4cc68"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "475.2 73.5 473.7 79.4 475.7 79.4 477.2 73.5 475.2 73.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_22-2",
    "data-name": "Degradado sin nombre 22",
    x1: 475.4,
    y1: 79.4,
    x2: 475.4,
    y2: 73.6,
    gradientTransform: "translate(12 -54.3) rotate(6.6)",
    xlinkHref: "#Degradado_sin_nombre_22"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "472.2 75.5 470.5 75.5 471.1 73.5 469.1 73.5 467.5 79.4 469.6 79.4 470.1 77.2 471.8 77.2 471.2 79.4 473.3 79.4 474.8 73.5 472.8 73.5 472.2 75.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_22-3",
    "data-name": "Degradado sin nombre 22",
    x1: 471.1,
    y1: 79.4,
    x2: 471.1,
    y2: 73.6,
    gradientTransform: "translate(31.2 -108.6) rotate(13.6)",
    xlinkHref: "#Degradado_sin_nombre_22"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M462.7,76.5c-.3.9-.2,1.7.2,2.2.5.7,1.4.8,2.1.8s1.6-.3,2.2-.7c0,0,.4-1.6.4-1.7h-1c-.1.3-.3.5-.4.6-.2.1-.3.2-.5.3-.4.1-.9,0-1.1-.4-.2-.8.1-1.7.6-2.3.7-.8,1.7-.7,1.7.5h1s.5-1.8.5-1.8c-.5-.6-1.2-.7-2-.7-2,0-3.3,1.3-3.8,3.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_22-4",
    "data-name": "Degradado sin nombre 22",
    x1: 465.5,
    y1: 79.4,
    x2: 465.5,
    y2: 73.6,
    gradientTransform: "translate(21.9 -83.9) rotate(10.5)",
    xlinkHref: "#Degradado_sin_nombre_22"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "481.4 73.6 480.3 77.7 481.5 77.7 481 79.4 484.7 79.4 485 78 482.2 78 482.4 77.2 484.8 77.2 485.1 75.8 482.8 75.8 483 75 485.8 75 486.2 73.6 481.4 73.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_22-5",
    "data-name": "Degradado sin nombre 22",
    x1: 483.3,
    y1: 79.4,
    x2: 483.3,
    y2: 73.6,
    gradientTransform: "translate(23.6 -91.2) rotate(11)",
    xlinkHref: "#Degradado_sin_nombre_22"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M454.5,76.9c.2.1.3.3.2.4,0,.2-.5.2-.9.2-.2.7-.8,1.6-1.7,2,.4,0,3,0,3.7,0,1.8-.2,2.5-1.9,1.7-2.8-.3-.3-1-.5-.8-.9.1-.2.5-.2.8-.2-.2-.5.3-1.8,1.2-2-.1,0-.9,0-1.6,0-.7,0-1.3,0-1.4,0-2.4,0-2.8,2.9-1.3,3.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_21",
    "data-name": "Degradado sin nombre 21",
    x1: 455.4,
    y1: 79.4,
    x2: 455.4,
    y2: 73.8,
    gradientTransform: "translate(385.6 -380) rotate(71.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#383a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a67ad"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M451.2,76.7c-.2.9-.6.8-.9.8-.3,0-.5-.2-.3-.8l.8-3.2h-2.4s-.9,3.6-.9,3.6c-.4,1.6.4,2.3,2.3,2.4,2,0,2.9-.7,3.4-1.9.1-.3.2-.7.3-1-.6-1.1-.2-2.6.8-3.1h-2.2s-.9,3.2-.9,3.2Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_21-2",
    "data-name": "Degradado sin nombre 21",
    x1: 450.6,
    y1: 79.4,
    x2: 450.6,
    y2: 73.8,
    gradientTransform: "translate(375.6 -374.4) rotate(70.9)",
    xlinkHref: "#Degradado_sin_nombre_21"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M440.5,74.7h.7c.7,0,.9.3.7.8-.2.6-.5.8-1.4.8h-.5l.4-1.5ZM438.4,73.4l-1.6,6h2.4l.5-1.9h1.9c1.2,0,2.3-.5,2.7-2,.4-1.6-.4-2.1-1.8-2.1h-4.1Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_21-3",
    "data-name": "Degradado sin nombre 21",
    x1: 440.8,
    y1: 79.4,
    x2: 440.8,
    y2: 73.8,
    gradientTransform: "translate(355.9 -362.8) rotate(69.2)",
    xlinkHref: "#Degradado_sin_nombre_21"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M444.1,73.5c.2.1,1.1.7.6,2.3-.2.7-.8,1.6-1.7,1.9l-.5,1.8h5.3c-.5-.2-1-.9-.9-1.7h-1.5l1.1-4.2h-2.4Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_21-4",
    "data-name": "Degradado sin nombre 21",
    x1: 445.2,
    y1: 79.4,
    x2: 445.2,
    y2: 73.8,
    gradientTransform: "translate(404.8 -373.4) rotate(75.1)",
    xlinkHref: "#Degradado_sin_nombre_21"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M460.1,73.5c-2.6,0-2.8,2.9-1.3,3.4.2.1.3.3.2.4,0,.2-.4.2-.8.2,0,.3,0,.6-.1.8.8,0,2.5.2,2.5-.9,0-.8-1.8-1.3-1.3-2.3.2-.3.4-.5.7-.6-.3.1-.5.3-.7.6-.5,1.2,1.7,1.5,1.4,2.6-.4,1.1-1.9,1-2.9,1-.3.5-.7.8-.9.8.4,0,2.3,0,3.1-.1,1.8-.2,2.5-1.8,1.7-2.8-.3-.3-1-.5-.8-.9.1-.2.6-.2,1-.2.2,0,.3,0,.4,0,0-.1.5-1.8.5-2,0,0-.3,0-.7,0-.4,0-.9,0-1.3,0s-.5,0-.7,0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_21-5",
    "data-name": "Degradado sin nombre 21",
    x1: 460,
    y1: 79.4,
    x2: 460,
    y2: 73.8,
    gradientTransform: "translate(405.1 -386.6) rotate(73.8)",
    xlinkHref: "#Degradado_sin_nombre_21"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M434,65.6s.3.2.4.5c0,0,.2.6.2,1.5.1,3.9-2.5,7.2-2.5,11,0,2.4.5,4.3,2.1,6.1,0,0,.2,0,.2-.1-.4-.5-1-1.4-1.3-2-.4-.8.4-1.2.9-1.7.8-.8,1.7-2.5,2-3.5-.3.4-.9.6-1.2.8.5-.3,1.2-1,1.5-1.4.2-.3.9-3.2.9-3.3-.5.4-1.1.7-1.6.9.6-.4,1.3-1,1.6-1.3.3-.3.4-2.4.2-2.7-.1.5-1.1,1.3-1.5,1.5.7-.7,1.1-1.1,1.4-1.8.3-.7-.3-2.2-.5-2.7,0,.2-.4.8-1.1,1.5,0,0,.8-1.4.9-1.6.2-1.3-1.9-1.7-2.5-1.7s0,0,0,0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_22-6",
    "data-name": "Degradado sin nombre 22",
    x1: -137.4,
    y1: 403.2,
    x2: -136.2,
    y2: 403.2,
    gradientTransform: "translate(-2354.1 1019.4) rotate(90) scale(6.9 -6.9)",
    xlinkHref: "#Degradado_sin_nombre_22"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M433.8,67.9c.1.2.2.5.2.6,0-.1-.1-.4-.2-.5,0,.4-.7,1.7-1,2.7-.3.9,0,1.3,0,1.9-.3-.7-.3-.8-.4-1-.4,1.4-1.2,1.2-.9,2.9-.2-.2-.2-.6-.3-.9-.4,3.4-1,5.7,1.6,8.7-.3-.7-.6-1.4-.7-2.2-.6-4.2,1.4-6.7,2.3-10.4.4-1.5.4-3,.1-3.8,0-.4-.4-.5-.4-.5.1.5,0,2-.2,2.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_23",
    "data-name": "Degradado sin nombre 23",
    x1: -149.1,
    y1: 404.9,
    x2: -148,
    y2: 404.9,
    gradientTransform: "translate(5886 -1928.6) rotate(-90) scale(13.5 -13.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b17a26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e0c076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f4de98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ecd582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e6ce6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4cc68"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M241.5,9.1s12.6-5.5,24.7-.7c7.6,3.1,12.9,7.6,14.9,16.5.8,3.5.7,6.8.5,8.9-.7,8.8-7.5,16.1-16.4,16.1s-16.1-7.2-16.1-16.1,1.2-7,3.3-9.7c2.2-3.5,7.2-6.6,12.9-6.4,3.2.1,6.2.9,8.7,2.6-1.2-4.8-7.2-10.6-19.3-10.6s-20.5,12-21.4,14.3c-1.1,2.9-6.3,18.8,5.8,31.1,12.1,12.2,25.2,23,26.4,24.8,0,0,10.5-10.6,16.1-16.1-4.8-1.7-12.5-.9-12.5-.9,0,0,16-2.8,19.3-6,2.1-2,4-4.8,5.8-8-4.8.9-12.2,0-12.2,0,0,0,13.4-1.2,14.9-6.3h0c1.2-3.6,1.8-7.7,1.4-12.3-2.8,2.1-11.1,4.8-11.1,4.8,0,0,10.4-5.3,10.2-10.1-.5-2-1.3-4.4-2-6-2.4,3.5-9,6.5-9,6.5,0,0,7.7-6.5,7.6-9.5-1.8-3.4-4-5.9-6.3-7.9-1.8,3.6-6.4,6.8-6.4,6.8,0,0,4.2-7.5,3.5-9-1.5-1-3.1-1.9-4.5-2.6-2,.6-4.2,2.2-5.2,4-1.2,2.3.3-2,2.3-5.3-2.3-.9-5.6-1.7-9.4-2-5.3.4-9.7,3.7-9.7,3.7,0,0,1.7-1.8,3.8-3.8-7,.4-14.6,2.8-20.6,9.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_11-11",
    "data-name": "Degradado sin nombre 11",
    x1: 262.8,
    y1: -1.1,
    x2: 262.8,
    y2: 80.2,
    gradientTransform: "translate(28.5 -85.7) rotate(19.6)",
    xlinkHref: "#Degradado_sin_nombre_11"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "41.3 5 2.7 5 0 19.5 11.2 19.5 3.1 63.5 19.4 63.5 27.5 19.5 38.6 19.5 41.3 5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M61.9,32.3l2.7-14.6h-1.1c-5.2,0-8.4,1.9-10.4,3.9l.5-2.4h-13.8l-8.2,44.3h14.5l4.3-23.5c1-5.4,4-7.6,10.2-7.6h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M97.9,22.2c-1.7-2.1-4.9-4.5-11-4.5-12.6,0-24,10.1-26.4,23.4-1.3,7,0,13.3,3.6,17.8,3.3,4,8.2,6.1,14.3,6.1s8.7-1.1,12.3-4.1l-.5,2.7h14.5l8.2-44.3h-14.5l-.6,3ZM94.2,41.7c-.6,2-1.4,3.7-2.6,5.1-2.4,2.9-5.5,4.4-9.1,4.4s-4.6-.8-6-2.4c-1.8-2.2-2.1-5.2-1.7-7.1h0c.8-4.1,4.6-10.3,11.7-10.3s6.9,2.9,7.6,5.3c.5,1.6.5,3.3,0,5.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "145.3 19.2 133.3 43.5 130.3 19.2 115.2 19.2 122.9 63.5 136.4 63.5 160.6 19.2 145.3 19.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M182.5,17.7c-12.7,0-24.9,10.6-27.4,23.6-1.2,6.4.3,12.3,4,16.8,3.7,4.4,9.1,6.8,15.3,6.8s9.2-1.4,13.3-4c4.3-2.6,8-6.4,10.9-11.2l.8-1.4h-15l-.3.3c-2.2,2.6-4.5,3.7-7.7,3.7s-4.7-.8-6.1-2.3c-.9-.9-1.4-2.1-1.5-3.4h31.4l.2-.6c2.7-8.5,1.9-15.5-2.4-21.2-3.5-4.6-9-7.1-15.6-7.1M171.3,35.2c1.2-1.9,4.2-4.9,9.2-4.9s4.4.7,5.8,2.1c.8.9,1.3,2,1.5,2.8h-16.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "213.6 5 202.7 63.5 217.3 63.5 228.1 5 213.6 5"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 418,
    y: 17.9,
    width: 50.1,
    height: 45.7
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 413.5,
    y: 9.8,
    width: 59.1,
    height: 61.9,
    transform: "translate(265.8 448.8) rotate(-71.8)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 379.4,
    y: 18,
    width: 54.9,
    height: 45.6
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 376.3,
    y: 7.5,
    width: 61,
    height: 66.8,
    transform: "translate(235.2 412) rotate(-70.9)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 300.1,
    y: 17.8,
    width: 60.1,
    height: 45.7
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 298.2,
    y: 4.4,
    width: 64.1,
    height: 72.4,
    transform: "translate(175.1 334.9) rotate(-69.2)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 345.5,
    y: 18.1,
    width: 40.1,
    height: 45.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 338.5,
    y: 15.5,
    width: 54.1,
    height: 50.4,
    transform: "translate(232.4 383.5) rotate(-75.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 455.7,
    y: 17.8,
    width: 44.3,
    height: 45.9
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 449.7,
    y: 13.1,
    width: 56.4,
    height: 55.3,
    transform: "translate(305.4 488.3) rotate(-73.8)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M299.2,76.9v-3.9h.9v3.8c0,1.5.7,2.2,1.8,2.2s1.8-.7,1.8-2.2v-3.8h.9v3.9c0,2-1,3-2.7,3s-2.7-1-2.7-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "317.7 73 317.7 79.8 316.9 79.8 313 74.7 313 79.8 312.1 79.8 312.1 73 312.9 73 316.8 78.1 316.8 73 317.7 73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M329.3,78.1h-3.4l-.7,1.7h-.9l2.9-6.8h.9l2.9,6.8h-1l-.7-1.7ZM328.9,77.3l-1.4-3.3-1.4,3.3h2.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "348.8 79 348.8 79.8 344.1 79.8 344.1 73 348.7 73 348.7 73.8 345 73.8 345 75.9 348.3 75.9 348.3 76.8 345 76.8 345 79 348.8 79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "361.8 79.8 361.8 74.9 359.5 79 359 79 356.7 74.9 356.7 79.8 355.8 79.8 355.8 73 356.6 73 359.3 77.8 361.9 73 362.7 73 362.7 79.8 361.8 79.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M375.4,75.4c0,1.5-1,2.4-2.7,2.4h-1.6v2.1h-.9v-6.8h2.5c1.7,0,2.7.9,2.7,2.4M374.5,75.4c0-1-.6-1.5-1.8-1.5h-1.6v3.1h1.6c1.2,0,1.8-.6,1.8-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M386.6,79.8l-1.4-2.1c-.1,0-.3,0-.4,0h-1.6v2.1h-.9v-6.8h2.5c1.7,0,2.7.9,2.7,2.4s-.5,1.8-1.4,2.2l1.5,2.3h-1ZM386.6,75.4c0-1-.6-1.5-1.8-1.5h-1.6v3.1h1.6c1.2,0,1.8-.6,1.8-1.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "399.2 79 399.2 79.8 394.5 79.8 394.5 73 399.1 73 399.1 73.8 395.4 73.8 395.4 75.9 398.7 75.9 398.7 76.8 395.4 76.8 395.4 79 399.2 79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M405.6,79l.3-.8c.5.5,1.3.8,2.1.8s1.6-.5,1.6-1.1c0-1.7-3.9-.6-3.9-3.1s.8-1.9,2.5-1.9,1.5.2,2.1.6l-.3.8c-.6-.4-1.2-.6-1.8-.6-1.1,0-1.6.5-1.6,1.1,0,1.7,3.9.6,3.9,3.1s-.8,1.9-2.5,1.9-2-.4-2.5-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M421.6,78.1h-3.4l-.7,1.7h-.9l2.9-6.8h.9l2.9,6.8h-1l-.7-1.7ZM421.3,77.3l-1.4-3.3-1.4,3.3h2.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 475.7,
    y: 73.2,
    width: 5.8,
    height: 6.6,
    transform: "translate(-6.1 77.7) rotate(-9.2)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 473.4,
    y: 73.3,
    width: 4.2,
    height: 6.3,
    transform: "translate(-5.6 55.3) rotate(-6.6)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 466.9,
    y: 72.7,
    width: 8.5,
    height: 7.5,
    transform: "translate(-4.8 112.9) rotate(-13.6)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 461.9,
    y: 72.8,
    width: 7.1,
    height: 7.2,
    transform: "translate(-6.1 86.5) rotate(-10.5)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 479.8,
    y: 73.1,
    width: 6.9,
    height: 6.8,
    transform: "translate(-5.7 94) rotate(-11)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 451.5,
    y: 72.4,
    width: 7.8,
    height: 8.1,
    transform: "translate(240.3 485.1) rotate(-71.8)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 446.6,
    y: 72.1,
    width: 8,
    height: 8.8,
    transform: "translate(231 477.3) rotate(-70.9)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 436.6,
    y: 71.7,
    width: 8.4,
    height: 9.5,
    transform: "translate(212.9 461.4) rotate(-69.2)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 441.6,
    y: 73.1,
    width: 7.1,
    height: 6.6,
    transform: "translate(257 487.1) rotate(-75.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 456.3,
    y: 72.8,
    width: 7.4,
    height: 7.3,
    transform: "translate(258.3 496.9) rotate(-73.8)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 426.4,
    y: 66.3,
    width: 17,
    height: 17.8,
    transform: "translate(64.7 315.5) rotate(-42.8)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 429,
    y: 65.3,
    width: 6.8,
    height: 17.4,
    transform: "translate(-6 59.4) rotate(-7.8)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M16.9,76.4c0,4.4-3.6,8-8,8s-8-3.6-8-8,3.6-8,8-8,8,3.6,8,8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 4.9,
    y: 75.1,
    width: 6.4,
    height: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M212.7,77.7h-12.6v-2.6h12.6v2.6ZM187.5,77.7h-12.6v-2.6h12.6v2.6ZM162.3,77.7h-12.6v-2.6h12.6v2.6ZM137.2,77.7h-12.6v-2.6h12.6v2.6ZM112,77.7h-12.6v-2.6h12.6v2.6ZM86.8,77.7h-12.6v-2.6h12.6v2.6ZM61.7,77.7h-12.6v-2.6h12.6v2.6ZM36.5,77.7h-12.6v-2.6h12.6v2.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "207 85.4 205.1 83.5 212.1 76.6 204.2 69.4 206 67.4 215.9 76.5 207 85.4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 215.7,
    y: -9.7,
    width: 94.3,
    height: 99.2,
    transform: "translate(1.8 90.3) rotate(-19.6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBanner);
export default __webpack_public_path__ + "static/media/logo_banner.fde8feb69f8094daa97c9dbc8a5a441a.svg";
export { ForwardRef as ReactComponent };